import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a50ce462"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ranking-detail-drawer" }
const _hoisted_2 = { class: "filter-row" }
const _hoisted_3 = { class: "filter-row__right" }
const _hoisted_4 = { class: "filter-row__left" }
const _hoisted_5 = { class: "ranking-detail-drawer" }
const _hoisted_6 = { class: "filter-row" }
const _hoisted_7 = { class: "filter-row__right" }
const _hoisted_8 = { class: "filter-row__left" }

import { computed, reactive, ref } from 'vue'
import dayjs from 'dayjs'
import { useI18n } from 'vue-i18n'
import { ElMessage } from 'element-plus'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import CmTable from '@/components/cmTable/index.vue'
import type { TableOpt } from '@/components/cmTable/types'
import ExportDropdown from '@/views/dashboard/_components/export-dropdown/export-dropdown.vue'
import PolicySelect from '@/views/dashboard/_components/policy-select/policy-select.vue'
import { PolicyType } from '@/views/dashboard/_enum/policy-type'
import { formatTableEmpty } from '@/utils/format'
import { formatTimeStamp } from '@/utils/time'
import { ACCESS_RESTRICTION_TRIGGER_STRATEGY_SWITCH } from '@/config/switch'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useParseTime } from '@/hooks'
import { getTimeRangeByEnum } from '@/utils/time'
import { TimeRange } from '@/views/dashboard/_components/time-range-select/time-range.enum'
import {
  TerminalViewService,
  DetailQueryParams as TerminalDetailQueryParams,
} from '@/views/dashboard/manage/internet-restriction/_components/terminal-view/terminal-view.service'
import {
  DomainViewService,
  DetailQueryParams as DomainDetailQueryParams,
} from '@/views/dashboard/manage/internet-restriction/_components/domain-view/domain-view.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'ranking-intercept-detail-drawers',
  props: {
    hasPermission: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props

const { t, locale } = useI18n()

const injector = useReflectiveInjector([TerminalViewService, DomainViewService])
const terminalViewService = injector.get(TerminalViewService)
const domainViewService = injector.get(DomainViewService)

const terminalDrawerVisible = ref(false)
const domainDrawerVisible = ref(false)

const terminalTitleName = ref('')
const domainTitleName = ref('')

const terminalTableRef = ref<{ getList?: (...args: unknown[]) => void | Promise<unknown> } | null>(null)
const domainTableRef = ref<{ getList?: (...args: unknown[]) => void | Promise<unknown> } | null>(null)
const { refreshList: refreshTerminalList } = useCmTableListRefresh(terminalTableRef)
const { refreshList: refreshDomainList } = useCmTableListRefresh(domainTableRef)

const pageOption = { pageNumName: 'page', pageSizeName: 'limit' }

const terminalDrawerTitle = computed(() => {
  void locale.value
  const name = terminalTitleName.value || '--'
  return t('accessRestriction.rankingDrawerTitleTerminalDomains', { name })
})

const domainDrawerTitle = computed(() => {
  void locale.value
  const name = domainTitleName.value || '--'
  return t('accessRestriction.rankingDrawerTitleDomainClients', { name })
})

/** 与 CmTable 同源；`page`/`limit` 由 CmTable 内部分页状态合并，不放在 v-model 上 */
const terminalQueryForm = reactive<
  Pick<TerminalDetailQueryParams, 'device_id' | 'key_word' | 'strategy_id'>
>({
  device_id: '',
  key_word: '',
  strategy_id: undefined,
})

function defaultDomainDetailTimeWindow(): {
  dateRange: [string, string]
  start_time: number
  end_time: number
} {
  const [st, et] = getTimeRangeByEnum(TimeRange.DAYS_30)
  const start = st ?? Math.floor(dayjs().subtract(30, 'day').valueOf() / 1000)
  const end = et ?? Math.floor(dayjs().valueOf() / 1000)
  return {
    dateRange: [dayjs.unix(start).format('YYYY-MM-DD'), dayjs.unix(end).format('YYYY-MM-DD')],
    start_time: start,
    end_time: end,
  }
}

const domainTimeInit = defaultDomainDetailTimeWindow()

const domainQueryForm = reactive<
  Pick<DomainDetailQueryParams, 'domain' | 'key_word' | 'group_id' | 'strategy_id' | 'start_time' | 'end_time'> & {
    dateRange: [string, string]
  }
>({
  domain: '',
  key_word: '',
  group_id: -1,
  strategy_id: undefined,
  dateRange: domainTimeInit.dateRange,
  start_time: domainTimeInit.start_time,
  end_time: domainTimeInit.end_time,
})

function formatInterceptCell(_row: unknown, val: unknown) {
  if (val == null || val === '') return '--'
  const n = Number(val)
  if (!Number.isFinite(n)) return '--'
  const ms = n < 1e12 ? n * 1000 : n
  return formatTimeStamp(ms, 'YYYY-MM-DD HH:mm')
}

function terminalDetailListApi(params: Record<string, unknown>) {
  return terminalViewService.getDetailList(params as unknown as TerminalDetailQueryParams)
}

function domainDetailListApi(params: Record<string, unknown>) {
  const merged = { ...domainQueryForm, ...params } as Record<string, unknown>
  const { dateRange: _dr, ...rest } = merged
  return domainViewService.getDetailList(rest as unknown as DomainDetailQueryParams)
}

const terminalTableOpt = computed<TableOpt>(() => {
  void locale.value
  const cols = [
    {
      prop: 'domain',
      label: t('accessRestriction.rankingDrawerColDomain'),
      columnOpt: { minWidth: 140 },
    },
    {
      prop: 'intercept_time',
      label: t('accessRestriction.rankingDrawerColInterceptTime'),
      columnOpt: { minWidth: 168 },
      formatter: formatInterceptCell,
    },
  ] as TableOpt['columns']
  if (ACCESS_RESTRICTION_TRIGGER_STRATEGY_SWITCH) {
    cols.push({
      prop: 'strategy_name',
      label: t('accessRestriction.rankingDrawerColStrategy'),
      columnOpt: { minWidth: 140 },
      formatter: (row: unknown, val: unknown) => formatTableEmpty(row, null, val),
    })
  }
  return {
    path: 'list',
    totalPath: 'total',
    rowKey: 'domain',
    columns: cols,
    bodyStyle: { padding: 0 },
    containerOpt: { style: 'flex: 1; min-height: 0; overflow: auto' },
    showActionBar: false,
    showSearch: false,
    showRightToolbar: false,
    height: '100%',
  }
})

const domainTableOpt = computed<TableOpt>(() => {
  void locale.value
  const cols = [
    {
      prop: 'computer_name',
      label: t('accessRestriction.rankingDrawerColComputerName'),
      type: 'COMPUTER' as const,
      columnOpt: { minWidth: 200 },
    },
    {
      prop: 'user_mark',
      label: t('accessRestriction.rankingDrawerColUserMark'),
      columnOpt: { minWidth: 120 },
    },
  ] as TableOpt['columns']
  if (ACCESS_RESTRICTION_TRIGGER_STRATEGY_SWITCH) {
    cols.push({
      prop: 'strategy_name',
      label: t('accessRestriction.rankingDrawerColStrategy'),
      columnOpt: { minWidth: 120 },
      formatter: (row: unknown, val: unknown) => formatTableEmpty(row, null, val),
      showOverflow: true,
    })
  }
  cols.push(
    {
      prop: 'system_ip',
      label: t('accessRestriction.rankingDrawerColLanIp'),
      type: 'IP' as const,
      columnOpt: { minWidth: 200 },
    },
    {
      prop: 'intercept_time',
      label: t('accessRestriction.rankingDrawerColInterceptTime'),
      columnOpt: { minWidth: 168 },
      formatter: formatInterceptCell,
    },
  )
  return {
    path: 'list',
    totalPath: 'total',
    rowKey: 'device_id',
    columns: cols,
    bodyStyle: { padding: 0 },
    containerOpt: { style: 'flex: 1; min-height: 0; overflow: auto' },
    showActionBar: false,
    showSearch: false,
    showRightToolbar: false,
    height: '100%',
  }
})

function onTerminalFilterChange() {
  void refreshTerminalList()
}

function onDomainFilterChange() {
  void refreshDomainList()
}

function onDomainDateRangeChange(val: [string, string] | null | undefined) {
  if (!val || val.length !== 2 || !val[0] || !val[1]) {
    const d = defaultDomainDetailTimeWindow()
    domainQueryForm.dateRange = d.dateRange
    domainQueryForm.start_time = d.start_time
    domainQueryForm.end_time = d.end_time
  } else {
    const [s, e] = useParseTime(val)
    if (s != null) domainQueryForm.start_time = s
    if (e != null) domainQueryForm.end_time = e
  }
  void refreshDomainList()
}

function downloadTerminalDetail(type: 0 | 1) {
  terminalViewService.download(
    type,
    { ...terminalQueryForm, page: 0, limit: 0 } as unknown as TerminalDetailQueryParams,
    t('accessRestriction.rankingExportTerminalIntercept', { name: terminalTitleName.value || '--' })
  )
}

function downloadDomainDetail(type: 0 | 1) {
  const { dateRange: _d, ...body } = domainQueryForm
  domainViewService.download(
    type,
    { ...body, page: 0, limit: 0 } as unknown as DomainDetailQueryParams,
    t('accessRestriction.rankingExportDomainIntercept', { name: domainTitleName.value || '--' })
  )
}

async function resolveDeviceIdByComputerName(computerName: string): Promise<string | undefined> {
  const res = await terminalViewService.getTerminalList({
    key_word: computerName,
    group_id: undefined,
    asc: false,
    sort: '',
    page: 1,
    limit: 30,
  })
  const list = res.list || []
  const exact = list.find((r) => r.computer_name === computerName)
  return exact?.device_id ?? list[0]?.device_id
}

/** 与「终端视图」排行点击一致：按终端查被拦截域名明细 */
async function openTerminalFromRanking(item: { name: string; count: number; device_id?: string }) {
  if (!props.hasPermission || !Number(item.count)) return
  let deviceId = (item.device_id || '').trim()
  if (!deviceId) {
    deviceId = (await resolveDeviceIdByComputerName(item.name)) || ''
  }
  if (!deviceId) {
    ElMessage.warning(t('accessRestriction.rankingTerminalResolveFailed'))
    return
  }
  terminalTitleName.value = item.name
  terminalQueryForm.device_id = deviceId
  terminalQueryForm.key_word = ''
  terminalQueryForm.strategy_id = undefined
  terminalDrawerVisible.value = true
}

/** 与「域名视图」排行点击一致：按域名查拦截终端明细；时间应与排行图一致 */
function openDomainFromRanking(item: {
  name: string
  count: number
  start_time?: number
  end_time?: number
}) {
  if (!props.hasPermission || !Number(item.count)) return
  domainTitleName.value = item.name
  domainQueryForm.domain = item.name
  domainQueryForm.group_id = -1
  domainQueryForm.key_word = ''
  domainQueryForm.strategy_id = undefined
  let start = item.start_time
  let end = item.end_time
  if (start == null || end == null) {
    const d = defaultDomainDetailTimeWindow()
    start = d.start_time
    end = d.end_time
    domainQueryForm.dateRange = d.dateRange
  } else {
    domainQueryForm.dateRange = [
      dayjs.unix(start).format('YYYY-MM-DD'),
      dayjs.unix(end).format('YYYY-MM-DD'),
    ]
  }
  domainQueryForm.start_time = start
  domainQueryForm.end_time = end
  domainDrawerVisible.value = true
}

__expose({
  openTerminalFromRanking,
  openDomainFromRanking,
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_drawer, {
      modelValue: terminalDrawerVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((terminalDrawerVisible).value = $event)),
      "destroy-on-close": "",
      size: "45%",
      title: terminalDrawerTitle.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(CmTable, {
            ref_key: "terminalTableRef",
            ref: terminalTableRef,
            modelValue: terminalQueryForm,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((terminalQueryForm) = $event)),
            "has-permission": _ctx.hasPermission,
            "table-opt": terminalTableOpt.value,
            api: terminalDetailListApi,
            "page-option": pageOption
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (_unref(ACCESS_RESTRICTION_TRIGGER_STRATEGY_SWITCH))
                    ? (_openBlock(), _createBlock(PolicySelect, {
                        key: 0,
                        size: "small",
                        class: "cm-ui-mr10",
                        disabled: !_ctx.hasPermission,
                        modelValue: terminalQueryForm.strategy_id,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((terminalQueryForm.strategy_id) = $event)),
                        "strategy-type": _unref(PolicyType).internet,
                        onChange: onTerminalFilterChange
                      }, null, 8, ["disabled", "modelValue", "strategy-type"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_input, {
                    modelValue: terminalQueryForm.key_word,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((terminalQueryForm.key_word) = $event)),
                    size: "small",
                    style: {"min-width":"300px"},
                    class: "search",
                    disabled: !_ctx.hasPermission,
                    placeholder: _ctx.$t('accessRestriction.rankingDrawerDomainKeywordPh'),
                    "suffix-icon": "el-icon-search",
                    onChange: onTerminalFilterChange
                  }, null, 8, ["modelValue", "disabled", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(ExportDropdown, {
                    "has-permission": _ctx.hasPermission,
                    "csv-i18n-key": "fileDispatch.exportCsv",
                    "excel-i18n-key": "fileDispatch.exportExcel",
                    onExport: downloadTerminalDetail
                  }, null, 8, ["has-permission"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "has-permission", "table-opt"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_drawer, {
      modelValue: domainDrawerVisible.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((domainDrawerVisible).value = $event)),
      "destroy-on-close": "",
      size: "45%",
      title: domainDrawerTitle.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(CmTable, {
            ref_key: "domainTableRef",
            ref: domainTableRef,
            modelValue: domainQueryForm,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((domainQueryForm) = $event)),
            "has-permission": _ctx.hasPermission,
            "table-opt": domainTableOpt.value,
            api: domainDetailListApi,
            "page-option": pageOption
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_el_input, {
                    modelValue: domainQueryForm.key_word,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((domainQueryForm.key_word) = $event)),
                    size: "small",
                    style: {"min-width":"270px"},
                    class: "search cm-ui-mr10",
                    disabled: !_ctx.hasPermission,
                    placeholder: _ctx.$t('common.phComputerRegUserIp'),
                    "suffix-icon": "el-icon-search",
                    onChange: onDomainFilterChange
                  }, null, 8, ["modelValue", "disabled", "placeholder"]),
                  (_unref(ACCESS_RESTRICTION_TRIGGER_STRATEGY_SWITCH))
                    ? (_openBlock(), _createBlock(PolicySelect, {
                        key: 0,
                        size: "small",
                        class: "cm-ui-mr10",
                        disabled: !_ctx.hasPermission,
                        modelValue: domainQueryForm.strategy_id,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((domainQueryForm.strategy_id) = $event)),
                        "strategy-type": _unref(PolicyType).internet,
                        onChange: onDomainFilterChange
                      }, null, 8, ["disabled", "modelValue", "strategy-type"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_date_picker, {
                    modelValue: domainQueryForm.dateRange,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((domainQueryForm.dateRange) = $event)),
                    disabled: !_ctx.hasPermission,
                    type: "daterange",
                    "unlink-panels": "",
                    size: "small",
                    style: {"width":"260px"},
                    class: "domain-detail-date-range",
                    "value-format": "YYYY-MM-DD",
                    "start-placeholder": _ctx.$t('common.startDate'),
                    "end-placeholder": _ctx.$t('common.endDate'),
                    onChange: onDomainDateRangeChange
                  }, null, 8, ["modelValue", "disabled", "start-placeholder", "end-placeholder"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(ExportDropdown, {
                    "has-permission": _ctx.hasPermission,
                    "csv-i18n-key": "fileDispatch.exportCsv",
                    "excel-i18n-key": "fileDispatch.exportExcel",
                    onExport: downloadDomainDetail
                  }, null, 8, ["has-permission"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "has-permission", "table-opt"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})